import type React from 'react';

import { Helmet } from 'react-helmet-async';

import type { SubEnvironment } from '@change-corgi/config/environments';
import { getFacebookNamespace } from '@change-corgi/config/facebook';
import { useUtilityContext } from '@change-corgi/core/react/utilityContext';

export const MetaTypeContainer: React.FC = () => {
	const { environment } = useUtilityContext();

	const env = environment.getDemoEnvironment() || environment.getEnvironment();
	const namespace = getFacebookNamespace(env as SubEnvironment);

	return <Helmet>{namespace && <meta property="og:type" content={`${namespace}:petition`} />}</Helmet>;
};
